<template>
  <card-item
    card="item_homework"
    :tabs="tabs"
    :activeTab="activeTab"
    :id="id"
    :infoKeys="infoKeys"
  />
</template>
<script>
export default {
  methods: {},
  props: ["id"],
  data() {
    return {
      tabs: [
        {
          title: "Информация",
          key: "information_card",
          component: () => import("./Info"),
        },
      ],
      activeTab: 0,
      infoKeys: [
        {
          key: "title",
          title: "Информация",
        },
      ],
    };
  },
};
</script>